import { render, staticRenderFns } from "./RequiredDocuments.vue?vue&type=template&id=41a1ef26&scoped=true"
import script from "./RequiredDocuments.vue?vue&type=script&lang=js"
export * from "./RequiredDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a1ef26",
  null
  
)

export default component.exports